const LogoMark = ({ size = 32, className = "" }) => (
  <div
    className={className}
    data-testid="logo-mark"
    style={{
      width: size,
      height: size,
      borderRadius: size * 0.1,
      backgroundColor: "#1A3DFF",
      overflow: "hidden",
      flexShrink: 0,
    }}
  >
    <img
      src="/logo512.png"
      alt="VB"
      width={size}
      height={size}
      style={{ display: "block", width: size, height: size, objectFit: "cover" }}
    />
  </div>
);

const LogoFull = ({ size = 32, className = "", inverted = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark size={size} />
    <span
      className={`font-bold tracking-[-0.02em] ${inverted ? "text-white" : "text-[#0A0A0A]"}`}
      style={{ fontSize: size * 0.53 }}
    >
      VeroBill
    </span>
  </div>
);

export { LogoMark, LogoFull };
export default LogoFull;
